import eight from "../assets/png/solvio-landing-page.png";
import five from "../assets/png/story-telling-game.png";
import four from "../assets/png/capture-app.png";
import one from "../assets/svg/projects/one.svg";
import seven from "../assets/svg/projects/seven.svg";
import six from "../assets/png/anootation-toolkit.png";
import three from "../assets/svg/projects/three.svg";
import two from "../assets/svg/projects/two.svg";

export const projectsData = [
  {
    id: 5,
    projectName: "Storytelling Game",
    projectDesc:
      "Designed and developed a storytelling game using React.js and Microsoft Azure Rest APIs which analyses the narration and sends analysis reports to the Parents",
    tags: ["React.js", "Microsoft Azure Rest APi's"],
    code: "",
    demo: "https://sparkstudio.co/",
    image: five,
  },
  {
    id: 6,
    projectName: "Spark studio's Core Product",
    projectDesc:
      "Lead technical member responsible for building this core product from scratch using Next.js and deploy using AWS",
    tags: ["Next.js", "AWS"],
    code: "",
    demo: "https://sparkstudio.co/",
    image: one,
  },
  {
    id: 3,
    projectName: "Solvio's Landing page",
    projectDesc:
      "Developed a fully responsive Landing Page from scratch and deployed using firebase.",
    tags: ["Next.js", "CSS", "Firebase"],
    code: "",
    demo: "https://trysolvio.ai/",
    image: eight,
  },
  {
    id: 1,
    projectName: "Authoring Tool for Subject Matter Experts",
    projectDesc:
      "Developed a multi-functional role-based Authoring tool where teachers can upload, crop questions, and create worksheets for students.",
    tags: ["React", "Ant Design", "Google Vision Api"],
    code: "",
    demo: "",
    image: six,
  },
  {
    id: 2,
    projectName: "Annotation Toolkit",
    projectDesc:
      "Developed an end-to-end internal platform tool that is used by 1000's annotators to annotate, train and automate the machine learning pipeline..",
    tags: ["React", "Express", "Material Ui"],
    code: "",
    demo: "",
    image: seven,
  },

  {
    id: 4,
    projectName: "Capture App",
    projectDesc:
      "Developed fully functional Mobile, Web, Desktop apps that enable users to extract a mathematical equation from an image by converting it to latex.",
    tags: ["React.js", "React native", "Electron"],
    code: "",
    demo: "",
    image: four,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
